import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=36a66335&scoped=true&"
import script from "./LogoIcon.vue?vue&type=script&lang=ts&"
export * from "./LogoIcon.vue?vue&type=script&lang=ts&"
import style0 from "./LogoIcon.vue?vue&type=style&index=0&id=36a66335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a66335",
  null
  
)

export default component.exports